import React from "react";
import "./services.css";
import { BiCheck } from "react-icons/bi";

const Services = () => {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>UI/UX Design</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Diseño de interfaces atractivas y funcionales.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Prototipado y wireframes interactivos.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Optimización de experiencia de usuario (UX).</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Auditoría y mejora de usabilidad.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Diseño adaptativo y responsivo para todos los dispositivos.</p>
            </li>
          </ul>
        </article>
        {/* END OF UI/UX */}
        <article className="service">
          <div className="service__head">
            <h3>Web Development</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Desarrollo de sitios web modernos y escalables.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Integración de sistemas y APIs.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Optimización de rendimiento y seguridad.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Desarrollo de aplicaciones web personalizadas.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Implementación de tiendas virtuales y comercio electrónico.</p>
            </li>
          </ul>
        </article>
        {/* WEB DEVELOPMENT */}
        <article className="service">
          <div className="service__head">
            <h3>Content Creation</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Creación de contenido digital para web y redes sociales.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Redacción de artículos y blogs optimizados para SEO.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Edición de imágenes y videos para campañas digitales.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Gestión de contenido en plataformas multimedia.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Desarrollo de estrategias de comunicación digital.</p>
            </li>
          </ul>
        </article>
        {/* END OF CONTENT CREATION */}
      </div>
    </section>
  );
};

export default Services;
